module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av284-3002427d73631d290373e8f71f5cd043.jpg";